import React, { useEffect, useRef } from 'react';

const YouCouldBeTheNextOne = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Ask for camera access
    navigator.mediaDevices.getUserMedia({ video: true })
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      })
      .catch((err) => {
        console.error("Error accessing camera:", err);
        alert("Unable to access camera. Please check permissions.");
      });

    // Optional: Stop camera when component unmounts
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(track => track.stop());
      }
    };
  }, []);

  return (
    <div>
      <h1 style={{ textAlign: 'center' }}>You Could be the Next..</h1>

      {/* Video feed */}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
        <video ref={videoRef} autoPlay playsInline style={{ width: '100%', maxWidth: '500px', borderRadius: '8px' }} />
      </div>

      <h1 style={{ textAlign: 'center', marginTop: '30px' }}>Enquire Now!</h1>
    </div>
  );
};

export default YouCouldBeTheNextOne;
